import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { TreeNode } from '../../components';
// Components
//import { MySettingHome } from './mySettingHome';
// Menus
import { MySettingProfile } from './profile/profile';
import { MySettingSecurity } from './security/security';
import { MySettingNotification } from './notification/notification';

const MySettingStack = createStackNavigator();

export const menus: TreeNode[] = [
  {
    id: 1,
    screen: 'my-setting-profile',
    label: 'Profile',
  },
  {
    id: 2,
    screen: 'my-setting-security',
    label: 'Security',
  },
  {
    id: 3,
    screen: 'my-setting-notification',
    label: 'Notification',
  },
  {
    id: 4,
    screen: 'admin-portal',
    label: 'Admin Portal',
  },

  {
    id: 9,
    screen: 'logout',
    label: 'Logout',
  },
];

// Required
export const MySettingsWebLinksConfig = {
  //'my-setting-home': 'my-setting-home',
  'my-setting-profile': 'my-setting-profile',
  'my-setting-security': 'my-setting-security',
  'my-setting-notification': 'my-setting-notification',
};

export const MySettingsPortalRoutes = () => (
  <MySettingStack.Navigator
    screenOptions={{
      headerShown: false,
    }}
    initialRouteName="my-setting-profile"
  >
    <MySettingStack.Screen
      name="my-setting-profile"
      component={MySettingProfile}
      options={{ title: 'My Settings - Profile' }}
    />
    <MySettingStack.Screen
      name="my-setting-security"
      component={MySettingSecurity}
      options={{ title: 'My Settings - Security' }}
    />
    <MySettingStack.Screen
      name="my-setting-notification"
      component={MySettingNotification}
      options={{ title: 'My Settings - Notification' }}
    />
  </MySettingStack.Navigator>
);
